import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParticipantModal = _resolveComponent("ParticipantModal")!
  const _component_n_result = _resolveComponent("n-result")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ParticipantModal, {
      showModal: _ctx.showModal,
      eventColor: _ctx.stringColor(_ctx.modalEventId, false),
      eventID: _ctx.modalEventId,
      statusHeaders: _ctx.statusHeaders
    }, null, 8, ["showModal", "eventColor", "eventID", "statusHeaders"]),
    (_ctx.modalEventId=='')
      ? (_openBlock(), _createBlock(_component_n_result, {
          key: 0,
          status: "404",
          title: "Joymeet",
          description: "You know life is always ridiculous."
        }))
      : _createCommentVNode("", true)
  ]))
}